
import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";

import { Qualifier as QualifierInterface } from "../../../Interfaces/qualifier";
import { Tournament } from "../../../Interfaces/tournament";
import { Stage, StageType } from "../../../Interfaces/stage";
import { Mappool } from "../../../Interfaces/mappool";
import { Team } from "../../../Interfaces/team";

import ContentButton from "../../../Assets/components/open/ContentButton.vue";
import ScoresView from "../../../Assets/components/open/ScoresView.vue";
import OpenTitle from "../../../Assets/components/open/OpenTitle.vue";
import BaseModal from "../../../Assets/components/BaseModal.vue";

const openModule = namespace("open");

@Component({
    components: {
        ContentButton,
        ScoresView,
        OpenTitle,
        BaseModal,
    },
    head () {
        return {
            title: this.$store.state.open.title,
            meta: [
                {hid: "description", name: "description", content: this.$store.state.open.tournament?.description || ""},

                {hid: "og:site_name", property: "og:site_name", content: this.$store.state.open.title},
                {hid: "og:title", property: "og:title", content: this.$store.state.open.title},
                {hid: "og:url", property: "og:url", content: `https://open.corsace.io${this.$route.path}`},
                {hid: "og:description", property: "og:description", content: this.$store.state.open.tournament?.description || ""},
                {hid: "og:image",property: "og:image", content: require("../../../Assets/img/site/open/banner.png")},
                
                {name: "twitter:title", content: this.$store.state.open.title},
                {name: "twitter:description", content: this.$store.state.open.tournament?.description || ""},
                {name: "twitter:image", content: require("../../../Assets/img/site/open/banner.png")},
                {name: "twitter:image:src", content: require("../../../Assets/img/site/open/banner.png")},
            ],
            link: [{rel: "canonical", hid: "canonical", href: `https://open.corsace.io${this.$route.path}`}],
        };
    },
    validate ({ params }) {
        return !params.id || !isNaN(parseInt(params.id));
    },
})
export default class Qualifier extends Vue {

    scoreView: "teams" | "players"  = "players";
    placementLock = false;

    @openModule.State tournament!: Tournament | null;
    @openModule.State myTeams!: Team[] | null;
    @openModule.State mappools!: Mappool[] | null;

    loading = false;
    qualifierData: QualifierInterface | null = null;

    optionsUTC: Intl.DateTimeFormatOptions = {
        month: "long", // Full month name (e.g., "July")
        day: "numeric", // Day of the month (e.g., "30")
        hour: "2-digit", // Two-digit hour (e.g., "23")
        hour12: false, // 24-hour format hour
        minute: "2-digit", // Two-digit minute (e.g., "59")
        timeZone: "UTC", // Set the time zone to UTC
        timeZoneName: "short", // Abbreviated time zone name (e.g., "UTC")
    };
    options: Intl.DateTimeFormatOptions = {
        month: "long", // Full month name (e.g., "July")
        day: "numeric", // Day of the month (e.g., "30")
        hour: "2-digit", // Two-digit hour (e.g., "23")
        hour12: false, // 24-hour format hour
        minute: "2-digit", // Two-digit minute (e.g., "59")
        timeZoneName: "short", // Abbreviated time zone name (e.g., "UTC")
    };

    get qualifiersStage (): Stage | null {
        return this.tournament?.stages.find(s => s.stageType === StageType.Qualifiers) ?? null;
    }

    async getQualifier (): Promise<QualifierInterface | null> {
        this.loading = true;
        let ID = 0;
        if (!this.$route.params.id) {
            if (!this.myTeams || !this.myTeams.some(t => t.qualifier?.ID)) {
                this.loading = false;
                return null;
            }
            
            ID = this.myTeams.find(t => t.qualifier?.ID)?.qualifier?.ID ?? 0;
        } else
            ID = parseInt(this.$route.params.id);

        const { data } = await this.$axios.get<{ qualifierData: QualifierInterface }>(`/api/qualifier/${ID}`);
        this.loading = false;
        return !data.success ? null : data.qualifierData;
    }

    async mounted () {
        this.qualifierData = await this.getQualifier();
        if (this.qualifierData) {
            await this.$store.dispatch("open/setMappools", this.qualifiersStage?.ID);
            this.$store.commit("open/setScores", this.qualifierData.scores);
            this.qualifierData.date = new Date(this.qualifierData.date);
        }
    }

    isOpen = false;
    togglePopup () {
        this.isOpen = !this.isOpen;
    }

}
